import { CLUSIVITY_TYPES } from "components/FormerEditor/common/constants";

const FEATURE_ALL = "all";
const FEATURE_GROUP = "group";
const FEATURE_PREVIEW = "preview";

export const FEATURE_TABS = {
  ALL: FEATURE_ALL,
  PREVIEW: FEATURE_PREVIEW,
  GROUP: FEATURE_GROUP
};

export const CLUSIVITY_OPTIONS = [
  {
    uid: CLUSIVITY_TYPES.INCLUSIVE,
    label: CLUSIVITY_TYPES.INCLUSIVE,
    description: "Shows all active and inactive features per product."
  },
  {
    uid: CLUSIVITY_TYPES.EXCLUSIVE,
    label: CLUSIVITY_TYPES.EXCLUSIVE,
    description: "Shows only the active features per product."
  },
  {
    uid: CLUSIVITY_TYPES.INCREMENTAL,
    label: CLUSIVITY_TYPES.INCREMENTAL,
    description:
      "Shows all the active features per product which are not included in the preceding product."
  }
];

const PRODUCT_FEATURE_ORDER = "PRODUCT_FEATURE_ORDER";
export const FEATURE_LIST_INTENT = {
  PRODUCT_FEATURE_ORDER
};

export const FEATURE_GROUPS_FORM_KEYS = {
  ADJUST_PRODUCT_LAYOUT: "form.adjustProductLayout",
  PRODUCT_LAYOUT: "productLayout"
};

export const FEATURE_FIELDS = [
  { key: "title", label: "Title" },
  { key: "uid", label: "Key" },
  { key: "tooltip", label: "Tooltip" },
  { key: "description", label: "Description" }
];
